import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    //
    label: 'What best fits your definition of a healthy diet?',
    field: 'imFitsDefi',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'lowCalories',
          value: 'A diet that is low in calories and is easy to follow.'
        },
        {
          key: 'lotsFruitsVege',
          value:
            'A diet that consists of lots of fruits, vegetables, whole grains, and lean animal and plant-based proteins.'
        },
        {
          key: 'highFats',
          value:
            'A diet that is mostly high in fats like coconut oil, avocados, olive oil and proteins like chicken, steak, and pork.'
        },
        {
          key: 'lowCarbs',
          value:
            'A diet that is low in carbs and mainly consists of veggies and meat and contains no desserts or junk food.'
        }
      ]
    }
  }, //

  {
    //
    label:
      'Which of the following five foods do you think are the highest in protein?',
    field: 'imHighestProtein',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'cheddarCheese',
          value:
            'Cheddar cheese, boiled eggs, almonds, chia seeds, steak, pork chops.'
        },
        {
          key: 'vanillaYogurt',
          value:
            'Vanilla yogurt, black beans, chickpeas, lentils, chicken breast.'
        },
        {
          key: 'eggWhites',
          value: 'Egg whites, chicken breast, greek yogurt, shrimp, lupini.'
        },
        {
          key: 'quinoa',
          value:
            'Quinoa, spirulina, protein bread, ground turkey, almond flour.'
        }
      ]
    }
  }, //

  {
    //
    label: 'What meal do you usually eat?',
    field: 'imUsuallyMeal',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'breakFast', value: 'Breakfast' },
        { key: 'lunch', value: 'Lunch' },
        { key: 'dinner', value: 'Dinner' },
        { key: 'snack1', value: 'Snack 1' },
        { key: 'snack2', value: 'Snack 2' },
        { key: 'snack3', value: 'Snack 3' },
        { key: 'snack4OrMore', value: 'Snack 4 or more' }
      ]
    }
  }, //

  {
    //
    label: 'What do you usually drink during the day ?',
    field: 'imUsuallyDrink',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'milk', value: 'Milk' },
        { key: 'water', value: 'Water (flavoured, carbonated, or plain)' },
        {
          key: 'teaOrCoffeeBlack',
          value: 'tea or coffee (black or with milk)'
        },
        {
          key: 'teaOrCoffeeSugar',
          value: 'Tea or coffee with sugar and/or cream'
        },
        { key: 'dietPop', value: 'Diet pop' },
        { key: 'juice', value: 'Juice' },
        { key: 'regularPop', value: 'Regular Pop' },
        { key: 'chocolateMilk', value: 'Chocolate milk' }
      ]
    }
  }, //

  {
    //
    label: 'For grains, what do you usually opt for?',
    field: 'imUsuallyOpt',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'whiteFlour', value: 'white or “wheat flour”' },
        { key: 'wholeWheat', value: 'whole wheat' },
        { key: 'wholeGrain', value: 'whole grain' },
        { key: 'multigrain', value: 'Multigrain' }
      ]
    }
  }, //

  {
    //
    label:
      'How many meals or snacks include a high protein option? Specifically, when do you eat at least one of the following: meat, seafood, greek/skyr yogurt, high-protein milk (with 50%-75% more protein), egg whites, firm tofu, seitan, edemame, or Lupini?',
    field: 'imMealSnackHighProtein',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'one', value: '1' },
        { key: 'two', value: '2' },
        { key: 'three', value: '3' },
        { key: 'fourOrMore', value: '4 or more' }
      ]
    }
  }, //

  {
    //
    label:
      'How many meals and snacks include veggies and/or fruit, not including potatoes?',
    field: 'imMealSnackIncludeVeggiesFruit',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'one', value: '1' },
        { key: 'two', value: '2' },
        { key: 'three', value: '3' },
        { key: 'fourOrMore', value: '4 or more' }
      ]
    }
  }, //

  {
    //
    // Education Slide
    field: 'imEducationSlide',
    type: 'info',
    educationalSlide:
      "Thanks for your answers - we'll review on our upcoming call. ",
    label: '',
    answer: {}
  }
];
export default questionsModels;
